<template>
    <div>
        <v-snackbar color="error" v-model="error.unknown">Une erreur inconnue s'est produite</v-snackbar>
        <v-snackbar color="warning" v-model="error.emailExists">Un utilisateur avec cet email existe déjà</v-snackbar>
        <v-form @submit.prevent="submit" ref="form" v-model="isValid">
            <v-text-field :rules="[v=>!!v]" label="Prénom" v-model="form.firstName"/>
            <v-text-field :rules="[v=>!!v]" label="Nom" v-model="form.lastName"/>
            <v-text-field :rules="[v=>!!v, v => /.+@.+\..+/.test(v)]" label="Email" type="email" v-model="form.email"/>
            <v-text-field label="UUID Société par défaut (facultatif)" v-model="form.defaultCompanyUuid"/>
            <v-text-field label="UUID Agence par défaut (facultatif)" v-model="form.defaultBranchUuid"/>
            <v-btn :loading="submitting" block color="primary" type="submit">Envoyer</v-btn>
        </v-form>
    </div>
</template>

<script>
	export default {
		name: "UserInvitation",
		data() {
			return {
				isValid: false,
				form: {
					email: "",
					firstName: "",
					lastName: "",
					defaultBranchUuid: "",
					defaultCompanyUuid: ""
				},
				error: {
					unknown: false,
					emailExists: false
				},
				submitting: false
			}
		},
		watch: {
			submitting(newVal) {
				this.$emit('input', newVal)
			},
			form: {
				handler() {
					this.$refs.form.resetValidation()
				},
				deep: true
			}
		},
		methods: {
			submit() {
				if (this.isValid) {
					this.submitting = true;
					this.error.unknown = false;
					this.error.emailExists = false;
					this.$http.post(this.$config.apiUrl + "/v2/users/invitation", this.form)
						.then((r) => {
							console.log(r.data)
							this.$emit('sent', r.data);
						})
						.catch(e => {
							if (e.response && e.response.status === 400) {
								this.error.emailExists = true
							} else this.error.unknown = true
						})
						.finally(() => this.submitting = false);
				} else this.$refs.form.validate();

			}
		}
	}
</script>

<style scoped>

</style>
